import React, { useEffect } from "react";
import { Icon, IconButton, useTheme } from "@mui/material";
import { motion } from "framer-motion";
import { styled } from "@mui/material/styles";
import useSmoothResponsiveFontSize from "../../_hook/useSmoothResponsiveFontSize";

// Motion-enhanced IconButton
const MotionIconButton = motion(IconButton);

// Styled Icon Component
const StyledIcon = styled(Icon)(({  }) => ({

}));

// CloseButton Component
const CloseButton = ({ handleClick, iconName = "close" }) => {
  const { palette } = useTheme();
  const customfontsize = useSmoothResponsiveFontSize({});

  // Animation Variants
  const variants = {
    hidden: { scale: 0, opacity: 0,rotate:0 },
    visible: {
      scale: 1,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 20,
      },
    },
    hover: {
      scale: 1.1,
      transition: {      type: "spring",
        stiffness: 100,
        damping: 20,},
    },
    tap: {
      scale: 0.95,
       rotate: 180  // Rotate on click
    },
  };

  useEffect(() => {}, [customfontsize]);
  return (
    <MotionIconButton
      onClick={handleClick}
      variants={variants}
      initial="hidden"
      animate="visible"
      whileHover="hover"
      whileTap="tap"
      style={{
        width: `${2 * customfontsize}px`,
        height: `${2 * customfontsize}px`,
        backgroundColor: "transparent",
        color: palette.grey[100],
        "&:hover": {
          color: palette.primary.main,
          
        },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.3s ease",
        borderRadius:"50%"
      }}
    >
      <StyledIcon
        customfontsize={customfontsize}
        style={{
          backgroundColor: "transparent",
          color: palette.grey[100],
          "&:hover": {
            color: palette.primary.main,
      
          },
            borderRadius:"50%",
            fontSize: `${2 * customfontsize}px`,
            padding: 0,
            margin: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.3s ease",
        }}
      >
        {iconName}
      </StyledIcon>
    </MotionIconButton>
  );
};

export default CloseButton;
